/* Plafonne les quantités à la limite « code du dresseur ».
   Agit sur la page produit et sur le panier. C'est une barrière d'interface :
   elle arrête un client normal, pas un script. L'enforcement dur demande une
   Cart & Checkout Validation Function (voir NOTES.md). */
(function () {
  var LIMITE = parseInt(document.documentElement.dataset.btLimite || '2', 10);
  if (!LIMITE || LIMITE < 1) return;

  var MSG = 'Max ' + LIMITE + ' stk. pr. person.';

  function alerte(input) {
    var box = input.closest('.dk-qte-wrap') || input.parentElement;
    if (!box) return;
    var old = box.querySelector('.dk-qte-msg');
    if (old) { old.remove(); }
    var p = document.createElement('p');
    p.className = 'dk-qte-msg';
    p.setAttribute('role', 'status');
    p.textContent = MSG;
    box.appendChild(p);
    setTimeout(function () { p.remove(); }, 4000);
  }

  function plafonner(input) {
    if (!input || input.dataset.btDone === '1') return;
    input.dataset.btDone = '1';
    if (!input.max || parseInt(input.max, 10) > LIMITE) input.max = String(LIMITE);

    input.addEventListener('change', function () {
      if (parseInt(input.value, 10) > LIMITE) { input.value = LIMITE; alerte(input); }
    });
    // Certains thèmes incrémentent via des boutons sans déclencher `change`.
    input.addEventListener('input', function () {
      if (parseInt(input.value, 10) > LIMITE) { input.value = LIMITE; alerte(input); }
    });
  }

  function scan() {
    document
      .querySelectorAll('input[name="quantity"], input[name^="updates["], .quantity__input')
      .forEach(plafonner);
  }

  scan();
  // Panier ajax, variantes, drawer : le DOM est remplacé, on re-scanne.
  new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });

  // Dernier filet : on borne aussi la valeur au moment de l'envoi du formulaire.
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.querySelector) return;
    f.querySelectorAll('input[name="quantity"], input[name^="updates["]').forEach(function (i) {
      if (parseInt(i.value, 10) > LIMITE) i.value = LIMITE;
    });
  }, true);
})();
